const getPath = (): string => window.location.pathname;

export { getPath };
